import style from './index.module.scss'
import { SpinLoading  } from 'antd-mobile'
function index() {
  return (
    <div className={style.loading}>
		 <SpinLoading style={{ '--size': '48px' }}/>
      {/*<img src="https://boweisou.oss-cn-shenzhen.aliyuncs.com/community/loadingpage.gif" alt="" />*/}
    </div>
  )
}

export default index
